import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  image_upload_status: {
    front_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_left_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    left_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_left_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_right_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    right_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_right_side: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    outer_windshield: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    inner_windshield: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    registrationNo: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    chassis: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    RC: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    odometer: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_left_tyre: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_left_tyre: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_right_tyre: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_right_tyre: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    cng: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
    selfie: {
      sql_upload_status: 0,
      s3_img_upload_status: 0,
      azure_img_upload_status: 0,
    },
  },
  video_upload_status: {
    rpm_meter_video: {
      s3_upload_status: 0,
      sql_upload_status: 0,
    },
    '360_view': {
      s3_upload_status: 0,
      sql_upload_status: 0,
    },
    engine_video: {
      s3_upload_status: 0,
      sql_upload_status: 0,
    },
    car_view: {
      s3_upload_status: 0,
      sql_upload_status: 0,
    },
    rpm_meter_video_video: {  
      s3_upload_status: 0,
      sql_upload_status: 0,
    },
  },
};

const image_upload_slice = createSlice ({
  name: 'image_upload_status',
  initialState,
  reducers: {
    set_image_upload_status: (state, action) => {
      const { image_name, status, type } = action.payload;
      console.log(image_name, status, type, "image upload");
      
      if (state.image_upload_status[image_name]) {
        state.image_upload_status[image_name][type] = status;
        console.log(state.image_upload_status[image_name][type], "updated");
      } else {
        console.warn(`Image type ${image_name} does not exist in the state.`);
      }
    },
    
   
    set_video_upload_status: (state, action) => {
      const { video_name, status, type } = action.payload;
      console.log(video_name, status, type, "video upload");
      
      if (state.video_upload_status[video_name]) {
        state.video_upload_status[video_name][type] = status;
        console.log(state.video_upload_status[video_name][type], "video updated");
      } else {
        console.warn(`Video type ${video_name} does not exist in the state.`);
      }
    },
    
   
    reset_upload_status: (state) => {
      state.image_upload_status = initialState.image_upload_status;
      state.video_upload_status = initialState.video_upload_status;
    },
  },
});

export const { 
  set_image_upload_status, 
  set_video_upload_status,  
  reset_upload_status       
} = image_upload_slice.actions;

export default image_upload_slice.reducer;